import { createApp } from 'vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import 'bootstrap-icons/font/bootstrap-icons.css'
import "@/assets/scss/app.scss"
import App from './App.vue'
import router from './router'
import i18n from './i18n'

const app = createApp(App)

app.use(i18n)
app.use(router)
app.mount('#app')
